import { render, staticRenderFns } from "./Cook.vue?vue&type=template&id=3fb3858b&scoped=true&"
import script from "./Cook.vue?vue&type=script&lang=js&"
export * from "./Cook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3858b",
  null
  
)

export default component.exports